import QuantisMarker from "./quantisMarker";

export default QuantisMarker;